/* eslint-disable react-hooks/exhaustive-deps */

import * as React from "react"
import { useRecoilValue } from "recoil"
import { userListSelector } from "../../../recoil/atoms/users"
import { UserModel } from "../../../recoil/atoms/users/types"
import {
  roomSelector,
  showInteractivityRequiredVisualSelector
} from "../../../recoil/atoms/room"
import { disableMediaAtom } from "../../../recoil/atoms/rtc"

const _LSRTCMediaConnection = () => {
  const userList = useRecoilValue(userListSelector)
  const showInteractivityRequiredVisual = useRecoilValue(
    showInteractivityRequiredVisualSelector
  )
  const { rtmpStreamEnable } = useRecoilValue(roomSelector)
  const disableMedia = useRecoilValue(disableMediaAtom)

  const canConnect = React.useCallback(
    ({
      userList,
      showInteractivityRequiredVisual,
      rtmpStreamEnable,
      disableMedia
    }: {
      userList: UserModel[]
      showInteractivityRequiredVisual: boolean
      rtmpStreamEnable: boolean
      disableMedia: boolean
    }) => {
      // media is disable then don't connect
      if (disableMedia) return false

      if (showInteractivityRequiredVisual) return false

      // If rtmpStreamEnable is true. ignore other cases
      if (rtmpStreamEnable) return true

      const isAnyonePresentWithMicOrCam = userList.findIndex(
        user => user.camEnabled || user.micEnabled || user.screenShareEnabled
      )

      if (isAnyonePresentWithMicOrCam === -1) return false

      const userCount = userList.length
      if (userCount <= 1) return false

      /**
       * 1. Interactivity is disable means Mod is present if Mod must Present is enabled
       * 1. Mod or broad is present with mic or cam ON
       * 1. More than two user
       */
      return true
    },
    []
  )

  const handleLSRTCMedia = React.useCallback(
    async ({
      userList,
      showInteractivityRequiredVisual,
      rtmpStreamEnable,
      disableMedia
    }) => {
      const meetOnline = window.MeetOnline.client()
      if (
        canConnect({
          userList,
          showInteractivityRequiredVisual,
          rtmpStreamEnable,
          disableMedia
        })
      ) {
        meetOnline.connectMedia()
      } else {
        meetOnline.disconnectMedia()
      }
    },
    []
  )

  React.useEffect(() => {
    handleLSRTCMedia({
      userList,
      showInteractivityRequiredVisual,
      rtmpStreamEnable,
      disableMedia
    })
  }, [
    userList,
    showInteractivityRequiredVisual,
    rtmpStreamEnable,
    disableMedia
  ])

  return null
}

const LSRTCMediaConnection = React.memo(_LSRTCMediaConnection)

export default LSRTCMediaConnection
